import KunLoading27 from './src/index'

KunLoading27.install = function (Vue) {
	Vue.component(KunLoading27.name, KunLoading27);
}

export default KunLoading27;
